<template>
  <v-dialog v-model="visible" width="500" max-width="350">
    <v-card>
      <v-card-title class="headline">Ativar cartão consumo</v-card-title>
      <v-card-text>
        <p class="body-1">{{ message }}</p>
      </v-card-text>
      <v-form style="padding: 15px;">
        <v-flex>
          <v-text-field v-mask="'####'" type="password" v-model="password" label="Senha"></v-text-field>
        </v-flex>
        <v-flex style="text-align: right; padding-top: 15px">
          <v-btn class="accent" @click="confirm()" :disabled="finishing">Confirmar</v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Orderservice from "../services/orderService";

export default {
  name: "ActivateCard",
  data() {
    return {
      consumptionCard: {},
      visible: false,
      message: "",
      password: null,
      finishing: false
    };
  },
  methods: {
    handleOpen(consumptionCard) {
      this.finishing = false;
      this.consumptionCard = consumptionCard;

      this.message = "Informe os 4 (quatro) últimos digitos do seu telefone";

      this.visible = true;
    },
    confirm() {
      this.finishing = true;
      if (this.consumptionCard.status === "ACTIVE")
        this.confirmConsumptionCard();
      else this.activeConsumptionCard();
    },
    async activeConsumptionCard() {
      try {
        if (this.password == null || this.password === "") {
          this.$info("Erro!", "Senha precisa ser informada", "error");
          return;
        }

        const res = await new Orderservice().activeConsumptionCard(
          this.consumptionCard.number,
          this.password
        );
        localStorage.setItem("visit", res.data);
        localStorage.setItem("consumptionCard", this.consumptionCard.number);

        this.$emit("activeCard");
      } catch (e) {
        this.$info("Erro ao ativar o cartão!", e.message, "error");
      }
    },
    async confirmConsumptionCard() {
      try {
        const res = await new Orderservice().confirmConsumptionCard(
          this.consumptionCard.number,
          this.password
        );
        localStorage.setItem("visit", res.data);
        localStorage.setItem("consumptionCard", this.consumptionCard.number);

        this.$emit("activeCard");
      } catch (e) {
        this.$info("Senha do cartão incorreta!", e.message, "error");
      }
    }
  }
};
</script>
